import React from 'react';
import PropTypes from 'prop-types';
import { path, propOr } from 'ramda';
import Payment from './Payment.jsx';
import { SummaryHeader } from './SummaryHeader.jsx';
import { SummaryFooter } from './SummaryFooter.jsx';
import { OfferSummaryRenderer } from './OfferSummaryRenderer.jsx';

const Summary = ({
  project,
  getMiddleText,
  getMiddleBoolean,
  middleFeatures,
  editDetails,
  editSouscription3,
  customerCardOptions,
  isDutyOfAdviceSkipped,
  offerCode,
  guarantees,
  PTIADeathGuarantees,
  spousePensionGuarantees,
  educationPensionGuarantees,
  disabilityGuarantees,
  invalidityGuarantees,
  displayRefundInformation,
  grantees,
  granteesCardOptions,
  editContract,
  editEffectDate,
  viewMode,
  prevTnsCommission,
  usersInformation,
  regimeObligatoire,
  isProjectEditable,
  editIsLocked
}) => {
  const offer = propOr({}, 'offer', project);
  const packs = propOr([], 'packs', offer);
  const effectDate = propOr('', 'effectDate', offer);
  const subscriptionStatus = path(['customer', 'subscriptionStatus'], project);
  const pricingLevel = propOr('', 'pricingLevel', project);
  const demography = propOr(null, 'demography')(project);
  const formulaLevelLabel = propOr(null, 'formulaLevelLabel')(project);
  const tariffStructureLabel = propOr(null, 'tariffStructureLabel')(project);

  return (
    <div className="flex flex-col gap-6">
      <SummaryHeader getMiddleText={getMiddleText} />

      <OfferSummaryRenderer
        offerCode={offerCode}
        getMiddleText={getMiddleText}
        getMiddleBoolean={getMiddleBoolean}
        grantees={grantees}
        packs={packs}
        effectDate={effectDate}
        editContract={editContract}
        editEffectDate={editEffectDate}
        editIsLocked={editIsLocked}
        viewMode={viewMode}
        demography={demography}
        formulaLevelLabel={formulaLevelLabel}
        project={project}
        tariffStructureLabel={tariffStructureLabel}
        pricingLevel={pricingLevel}
        isDutyOfAdviceSkipped={isDutyOfAdviceSkipped}
        guarantees={guarantees}
        PTIADeathGuarantees={PTIADeathGuarantees}
        spousePensionGuarantees={spousePensionGuarantees}
        educationPensionGuarantees={educationPensionGuarantees}
        disabilityGuarantees={disabilityGuarantees}
        invalidityGuarantees={invalidityGuarantees}
        regimeObligatoire={regimeObligatoire}
        customerCardOptions={customerCardOptions}
        granteesCardOptions={granteesCardOptions}
        onEditBeneficiaries={editDetails}
        isProjectEditable={isProjectEditable}
      />

      <Payment
        getMiddleText={getMiddleText}
        getMiddleBoolean={getMiddleBoolean}
        displayRefundInformation={displayRefundInformation}
        middleFeatures={middleFeatures}
        project={project}
        onEdit={editSouscription3}
        offerCode={offerCode}
        prevTnsCommission={prevTnsCommission}
        usersInformation={usersInformation}
        isProjectEditable={isProjectEditable}
      />

      <SummaryFooter
        getMiddleText={getMiddleText}
        subscriptionStatus={subscriptionStatus}
      />
    </div>
  );
};

Summary.propTypes = {
  project: PropTypes.object,
  getMiddleText: PropTypes.func,
  getMiddleBoolean: PropTypes.func,
  middleFeatures: PropTypes.object,
  editDetails: PropTypes.func,
  editSouscription3: PropTypes.func,
  customerCardOptions: PropTypes.array,
  isDutyOfAdviceSkipped: PropTypes.bool,
  offerCode: PropTypes.string,
  guarantees: PropTypes.array,
  PTIADeathGuarantees: PropTypes.object,
  spousePensionGuarantees: PropTypes.object,
  educationPensionGuarantees: PropTypes.object,
  disabilityGuarantees: PropTypes.object,
  invalidityGuarantees: PropTypes.object,
  displayRefundInformation: PropTypes.bool,
  grantees: PropTypes.array,
  granteesCardOptions: PropTypes.func,
  editContract: PropTypes.func,
  editEffectDate: PropTypes.func,
  editIsLocked: PropTypes.bool
};

export default Summary;
